import {app} from '../../app';

app.service('OkModal', modal);

/** @ngInject */
function modal($uibModal) {
    return (messageKey, titleKey, okButtonTextKey) =>
        $uibModal.open({
            component: 'spOk',
            resolve: {
                messageKey: () => messageKey,
                titleKey: () => titleKey,
                okButtonTextKey: () => okButtonTextKey,
            },
        }).result;
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-ok/sp-ok.modal.js